export default __webpack_public_path__ + "static/media/RolloverMini.74203449.png";